import { account2OptionsMixin } from "@ba/visary-account-common-vue";

export default {
  mixins: [account2OptionsMixin],
  computed: {
    passwordMinLength() {
      return this.$t("formMessages.minLength", {
        0: this.$tc(
          "pluralization.character",
          this.accountOptions?.password?.minLength ?? 0
        )
      })
    },
    passwordMinCapitalLetters() {
      return this.$t("formMessages.minLetters", {
        0: this.$tc(
          "pluralization.capitalLetter",
          this.accountOptions?.password?.minCapitalLetters ?? 0
        )
      })
    },
    passwordMinCursiveLetters() {
      return this.$t("formMessages.minLetters", {
        0: this.$tc(
          "pluralization.cursiveLetter",
          this.accountOptions?.password?.minCursiveLetters ?? 0
        )
      })
    },
    passwordMinDigits() {
      return this.$t("formMessages.minDigits", {
        0: this.$tc(
          "pluralization.minDigit",
          this.accountOptions?.password?.minDigits ?? 0
        )
      })
    },
    passwordMinSpecialCharacters() {
      return this.$t("formMessages.minSpecialCharacters", {
        0: this.$tc(
          "pluralization.minSpecialCharacter",
          this.accountOptions?.password?.minSpecialCharacters ?? 0
        ),
        1: this.accountOptions?.password?.specialCharacters ?? ""
      })
    },
    passwordMaxLength() {
      return this.$t("formMessages.maxLength", {
        0: this.$tc(
          "pluralization.character",
          this.accountOptions?.password?.maxLength ?? 0
        )
      })
    }
  }
}
